<template>
  <div>
    <div id="north">
      <header-info cur="1"></header-info>
      <div id="uList">
        <table>
          <tbody>
            <tr class="l_header">
              <th>名称</th>
              <th>学习情况</th>
            </tr>
            <tr class="item">
              <td>预习</td>
              <td>{{getCount(studyProcessData.preview).toFixed(2)}}%（进度）</td>
            </tr>
            <tr class="item">
              <td>学习</td>
              <td>{{getCount(studyProcessData.study).toFixed(2)}}%（进度）</td>
            </tr>
            <tr class="item">
              <td>测试</td>
              <td>{{studyProcessData.exam.length?studyProcessData.exam[0].grade:'--'}}（分）</td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
export default {
  name: 'ViewGrades',
  components: {
    HeaderInfo
  },
  data() {
    return {
      studyProcessData: {
        preview: [],
        study: [],
        exam: []
      }
    }
  },
  mounted() {
    this.getStudentGrade()
  },
  computed: {

  },

  methods: {
    getCount (item) {
      var sum = 0
      if (item) {
        for (let i = 0; i < item.length; i++) {
          sum = sum + item[i].finished
        }
        return item.length ? (sum / item.length).toFixed(2) * 100 : item.length
      } else {
        return 0
      }
    },
    async getStudentGrade() {
      const url = '/online_student_study_process/'
      await this.$http.get(url, {
        params: {
          onlineStudentId: this.$route.query.id
        }
      }).then((data) => {
        this.studyProcessData = data.data
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="less" scoped>
#uList {
  width: 100%;
}

#uList table .action {
  width: 60px;
}

#uList table {
  text-align: center;
  border-collapse: collapse;
  background: #ffffff;
  width: 100%;
  table-layout: fixed;
}

#uList .l_header th {
  /*line-height: 44px;*/
  padding: 8px 1px;
  border: 1px solid #e2d8d8;
  font-weight: lighter;
}

#uList td {
  padding: 8px 1px;
  border-right: 1px solid #e2d8d8;
}

#uList tr {
  border: 1px solid #e2d8d8;
}

#uList tr:hover {
  background: #f0f9f9;
}

#uList tr.l_header:hover {
  background: #f7f7f7;
}

#uList tr.l_header {
  border: 1px solid #e2d8d8;
  background: #f7f7f7;
  border: none;
}
</style>
